import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import trusted from '~/assets/img/footer/picto-trustedShops.png';
export default {
  name: 'TrustedShops',
  data: function data() {
    return {
      trusted: trusted
    };
  }
};